import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiServer from "../../constants/apiServer";
import { post, put } from "../../utils/api";
import AdaAlert from "../../common/AdaAlert";
import PopupLoading from "../../common/PopupLoading";
import { useParams } from "react-router-dom";
import SquareLoading from "../../common/SquareLoading";
import useFetchInfo from "../../utils/useFetchInfo";
import { checkFormValidate } from "../../utils/commonFuncs";
import ArtistTypeForm from "./ArtistTypeForm";
import EmptyPage from "../../common/EmptyPage";
import { handleApiError, handleApiSuccess } from "../../utils/errorHandler";

const EditArtistType = () => {
    const navigate = useNavigate();

    const { artistTypeId } = useParams();

    const [artistTypeInfoValues, setArtistTypeInfoValues] = useState({
        nameENG: "",
        nameMM: "",
    });

    const [artistTypeErrorValues, setArtistTypeErrorValues] = useState({});

    const handleChangeValue = (event) => {
        const { name, value } = event.target;
        setArtistTypeInfoValues((prevInfo) => {
            return {
                ...prevInfo,
                [name]: value,
            };
        });
        delete artistTypeErrorValues[name];
        setArtistTypeErrorValues(artistTypeErrorValues);
    };

    const [updateLoading, setUpdateLoading] = useState(false);
    const [errorUpdate, setErrorUpdate] = useState("");

    const { data, isLoading, error } = useFetchInfo(
        `${apiServer.artist_type.detail}/${artistTypeId}`
    );

    useEffect(() => {
        setArtistTypeInfoValues({
            nameENG: data?.name?.eng,
            nameMM: data?.name?.mm,
        });
    }, [data, isLoading, error]);

    const handleUpdateArtistType = async (event) => {
        event.preventDefault();
        const checkGeneralInfo = checkFormValidate({
            nameENG: artistTypeInfoValues["nameENG"],
            nameMM: artistTypeInfoValues["nameMM"],
        });
        setArtistTypeErrorValues(checkGeneralInfo);
        const errorStateList = Object.keys(checkGeneralInfo);
        if (errorStateList.length === 0) {
            setUpdateLoading(true);
            const fd = new FormData();
            fd.append("id", artistTypeId);
            
            // Create name object with en and mm properties as expected by backend
            const nameObject = {
                eng: artistTypeInfoValues["nameENG"],
                mm: artistTypeInfoValues["nameMM"]
            };
            
            // Append name as JSON string
            fd.append('name', JSON.stringify(nameObject));
            
            Object.keys(artistTypeInfoValues).forEach((element) => {
                if (element !== 'nameENG' && element !== 'nameMM') {
                    fd.append(element, artistTypeInfoValues[element]);
                }
            });
            const updateArtistURL = `${apiServer.artist_type.update}/${artistTypeId}`;
            try {
                const response = await put(updateArtistURL, fd);
                const responseData = handleApiSuccess(response, setUpdateLoading);                
                
                navigate("/artist_types", {
                    replace: true,
                    state: { status: "success", message: responseData.message },
                });
            } catch (errors) {
                handleApiError(errors, setErrorUpdate, setUpdateLoading);
            }
        }
    };

    const handleCancel = () => {
        navigate("/artist_types", { replace: true });
    };

    if (isLoading)
        return <SquareLoading text="Retrieving Artist Type Information" />;
    if (updateLoading) return <PopupLoading text={"Uploading Artist Type"} />;
    if (error) return <EmptyPage text={error} />;

    return (
        <>
            <ArtistTypeForm
                onCreate={handleUpdateArtistType}
                onCancel={handleCancel}
                infoValues={artistTypeInfoValues}
                errorValues={artistTypeErrorValues}
                onChangeValue={handleChangeValue}
                formTitle={"Update Artist Type"}
                onSubmitName={"Update"}
            />
            {errorUpdate !== "" && (
                <AdaAlert type="error" message={errorUpdate} />
            )}
        </>
    );
};

export default EditArtistType;
